var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPianobgelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc930;}.cls-2{fill:#ffa0dc;}.cls-3{fill:#3c2c5b;}.cls-4{fill:#cecece;}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 402.64,
    y1: 111.82,
    x2: -76.26,
    y2: 503.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff41ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 297,
    y1: 274.49,
    x2: 531.79,
    y2: -0.84,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106,168.7l44.66.35V344h-16.2a33.57,33.57,0,0,1-33.57-33.57V174.33l3.76-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.44,169.05H150.66V344h49.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.27,169.05H200.5V344h49.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,169.05H250.27V344H300Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.82,169.05H300V344h49.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.88,169.05l41.91-.29,7.86,5.57V310.39A33.57,33.57,0,0,1,366.07,344H349.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.46,91.57H366.07a33.57,33.57,0,0,1,33.58,33.57v49.19h-34l-15.56,17.14L334.5,174.33H265.82l-15.08,26-16-26H166L150.49,202.5l-15.56-28.17h-34V125.14A33.57,33.57,0,0,1,134.46,91.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.49,149.09A19.08,19.08,0,1,0,131.41,130,19.07,19.07,0,0,0,150.49,149.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.49,142.05a12,12,0,1,0-12-12A12,12,0,0,0,150.49,142.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.81,136.18a6.17,6.17,0,1,0-6.16-6.17A6.17,6.17,0,0,0,189.81,136.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.67,344V174.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.27,344V272.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M300.45,344V174.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M349.88,344V272.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.66,344V272.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M399.65,174.33H100.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.93,174.33H166v93.79a7.74,7.74,0,0,1-7.75,7.75H142.68a7.74,7.74,0,0,1-7.75-7.75V174.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.72,174.33h31.1v93.79a7.74,7.74,0,0,1-7.75,7.75h-15.6a7.73,7.73,0,0,1-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.5,174.33h31.11v93.79a7.74,7.74,0,0,1-7.75,7.75H342.25a7.74,7.74,0,0,1-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.88,276.93,66.21,310.17A2.07,2.07,0,0,0,65.06,312l-2.32,91.4a1.27,1.27,0,0,1-.69,1.16L43.63,415a17.59,17.59,0,0,0-6.38,24,17.26,17.26,0,0,0,7.07,6.72A17.5,17.5,0,0,0,68,438.19a17.78,17.78,0,0,0,2-8.11v-25l1.51-54.57,57.46-25.95-3.59,50.39a1.44,1.44,0,0,1-.81,1.28l-18.77,10.54a17.58,17.58,0,0,0-6.37,24,17.14,17.14,0,0,0,7.07,6.72,17.5,17.5,0,0,0,23.63-7.53,17.88,17.88,0,0,0,2-8.11V371.92l6.14-94.18A.86.86,0,0,0,136.88,276.93ZM71.55,343.88l.69-23.74a.64.64,0,0,1,.35-.58l57.46-28.27a.81.81,0,0,1,1.16.81l-1.74,24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M463.7,52.68a2.82,2.82,0,0,0-2.73,0L424.09,73.19a2.77,2.77,0,0,0-1.42,2.35v60.6l-23.24,13.55a19,19,0,0,0-6.87,26.07,19.42,19.42,0,0,0,7.72,7.34,19.18,19.18,0,0,0,28-16.94l3-62.76L463.7,84.77a2.79,2.79,0,0,0,1.41-2.36V55A3,3,0,0,0,463.7,52.68Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPianobgelement);
export default __webpack_public_path__ + "static/media/piano bg element.f09804b1442b295d8227c858c7fd25e0.svg";
export { ForwardRef as ReactComponent };